var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachEvidence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.854,
    height: 14,
    viewBox: "0 0 7.854 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hzovh0mu7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1097.854-702.85a3.924 3.924 0 0 1-3.927 3.85 3.924 3.924 0 0 1-3.927-3.85v-7.35a2.837 2.837 0 0 1 2.856-2.8 2.837 2.837 0 0 1 2.856 2.8v5.95a1.75 1.75 0 0 1-1.785 1.75 1.75 1.75 0 0 1-1.785-1.75v-5.25h1.071v5.25a.668.668 0 0 0 .714.7.668.668 0 0 0 .714-.7v-5.95a1.75 1.75 0 0 0-1.785-1.75 1.75 1.75 0 0 0-1.785 1.75v7.35a2.837 2.837 0 0 0 2.856 2.8 2.837 2.837 0 0 0 2.856-2.8v-6.65h1.071z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ghbbejyc4b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-201 0h1440v-837H-201z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hzovh0mu7a)",
    transform: "translate(-1090 713)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ghbbejyc4b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#748a94",
    d: "M1085-718h17.854v24H1085z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachEvidence);
export default __webpack_public_path__ + "static/media/attach-evidence.b5e1b71d1fa5658f577919459810dcdd.svg";
export { ForwardRef as ReactComponent };